import { render, staticRenderFns } from "./walletManage.vue?vue&type=template&id=bd1f5f1c&scoped=true&"
import script from "./walletManage.vue?vue&type=script&lang=js&"
export * from "./walletManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1f5f1c",
  null
  
)

export default component.exports